import { IllumioEventEmitter } from "../common/event_emitter";
import { IllumioDate } from "../common/illumio_date.js";
import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportUtils from "../common/support_utils.js";

import { AssetDownload } from "./asset-download.js";
import { EulaModel, EulaView, EulaController } from "./eula-mvc.js";

export class AssetListingModel extends IllumioEventEmitter {
    /**
     * Example of metadata:
     * metadata: {
     *   product: 'PCE Software',
     *   type: 'Upgrade',
     *   display_categories: {
     *     pce: { display_label: PCE' },
     *   },
     *   access_authorized: true,
     *   eula_required: true,
     * }
     */
    constructor() {
        super();

        // The owner object is responsible for setting the following model data.
        this.metadata = null;
        this.data = null;

        this.downloadType = null;
    }

        getAsset(assetId) {
            if (this.data && this.data.software_components) {
                if (this.data.software_components.constructor===Array) {
                    for (let i=0;i<this.data.software_components.length;i++) {
                        if (this.data.software_components[i].id===assetId) {
                            return this.data.software_components[i];
                        }
                    }
                } else {
                    // const assetVersions = Object.keys(this.data.software_components);
                    for (let version in this.data.software_components) {
                        for (let i=0;i<this.data.software_components[version].length;i++) {
                            if (this.data.software_components[version][i].id===assetId) {
                                return this.data.software_components[version][i];
                            }
                        }
                    }
                }
            }

            return null;
        }

        getSoftwareRelease(version) {
            if (this.data && this.data.software_releases) {
                for (let i=0;i<this.data.software_releases.length;i++) {
                    if (this.data.software_releases[i].version===version) {
                        return this.data.software_releases[i];
                    }
                }
            }

            return null;
        }
}

export class AssetListingView extends IllumioEventEmitter {
    constructor(model) {
        super();

        this.model = model;

        // this.downloadEvent = new IllumioEvent(this);

        // The owner object will set the element object.
        this.downloadElement = null;
        this.eulaElement = null;
        this.errorElement = null;
        
    }
    

    getChecksumsAnchorTags(record) {
        let anchorTags = null;

        if (record) {
            anchorTags = [];

            anchorTags.push(IllumioDomUtils.createAnchorTag('/software/checksum/'+record.id+'?type=sha256', 'SHA-256'));
            anchorTags.push(document.createTextNode(' '));
            let signingKeyAnchor = null;
            if (record.has_package_public_key) {
                signingKeyAnchor = IllumioDomUtils.createAnchorTag('/software/checksum/'+record.id+'?type=signingkey', 'Package Signing Key');
                anchorTags.push(signingKeyAnchor);
            }

            const anchorTagsForEachHandler = function(item) {
                if (item.constructor!==Text) {
                    item.dataset['gaEventLabel'] = item.innerText + '|' + record.version + '|' + record.file_name + '|' + this.model.downloadType;
                    item.onclick = this.checksumAnchorOnClickHandler;
                }
            };
            anchorTags.forEach(anchorTagsForEachHandler.bind(this));
            if (record.has_package_public_key) {
                const tooltipText = document.createElement('div');
                tooltipText.classList.add('ilo-tooltip-text');
                tooltipText.appendChild(document.createTextNode('For information about the signing key, see the '));
                tooltipText.appendChild(IllumioDomUtils.createNode('i', 'Deployment Guide'));
                tooltipText.appendChild(document.createTextNode(' in the documentation.'));

                const signingKeyIcon = document.createElement('i');
                signingKeyIcon.classList.add('fa');
                signingKeyIcon.classList.add('fa-info-circle');

                const tooltip = document.createElement('div');
                tooltip.classList.add('ilo-tooltip');
                tooltip.appendChild(signingKeyIcon);
                tooltip.appendChild(tooltipText);

                if (signingKeyAnchor) {
                    signingKeyAnchor.appendChild(tooltip);
                } else {
                    anchorTags.push(tooltip);
                }
            }
        }

        return anchorTags;
    }

    createRecordViewDOM(record, mode) {
        let rootElement = null;
        let columnsElement = null;

        if (record) {
            const releaseDate = new IllumioDate(record.release_date);
            // console.debug(`»» releaseDate: ${releaseDate.constructor.name}`);
            // console.debug(releaseDate);
            const releaseDateString = (releaseDate) ? releaseDate.toShortDateString() : 'N/A';
            if (mode==='desktop') {
                rootElement = document.createElement('tr');

                rootElement.appendChild(IllumioDomUtils.createTableCell(record.name));
                // rootElement.appendChild(IllumioDomUtils.createTableCell(IllumioDomUtils.createNode('nobr', releaseDateString)));
                // rootElement.appendChild(IllumioDomUtils.createTableCell(IllumioDomUtils.createNode('nobr', record.version_display)));
                rootElement.appendChild(IllumioDomUtils.createTableCell(releaseDateString));
                rootElement.appendChild(IllumioDomUtils.createTableCell(record.version_display));
            } else {
                rootElement = document.createElement('div');
                rootElement.classList.add('row');

                columnsElement = document.createElement('div');
                columnsElement.classList.add('small-16');
                columnsElement.classList.add('columns');

                columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Description'));
                columnsElement.appendChild(IllumioDomUtils.createNode('div', record.name));
                columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Release Date'));
                columnsElement.appendChild(IllumioDomUtils.createNode('div', releaseDateString));
                columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Version'));
                columnsElement.appendChild(IllumioDomUtils.createNode('div', record.version_display));
                let fileNameLabel = 'Filename';
                let fileNameLabelClassName = '';
                if (record.software_type==='k8s' && record.alert_text) {
                    fileNameLabel = 'Notes';
                } else if (record.software_type==='k8s') {
                    fileNameLabel = ' ';
                    fileNameLabelClassName = 'blank';
                }
                columnsElement.appendChild(IllumioDomUtils.createNode('div', fileNameLabel, fileNameLabelClassName));
            }

            let anchorTag = null;
            let zipAnchorTag = null;
            let alertTextAsDescriptionDiv = null;
            if (record.software_type==='k8s' && record.file_name.match(/^https\:\/\//)) {
                const iconElement = document.createElement('i');
                iconElement.classList.add('fa');
                iconElement.classList.add('fa-external-link');

                anchorTag = IllumioDomUtils.createAnchorTag(record.file_name, 'Download ', 'button');
                anchorTag.target = 'illumio_support';
                anchorTag.setAttribute('style', 'float: left !important');
                anchorTag.appendChild(iconElement);

                if (record.alert_text && record.alert_text.length>10) {
                    alertTextAsDescriptionDiv = document.createElement('div');
                    const alertElement = IllumioDomUtils.parseHtml(record.alert_text);
                    const sanitizedAlertElement = IllumioDomUtils.sanitizeDOMTree(alertElement);
                    alertTextAsDescriptionDiv.appendChild(sanitizedAlertElement);
                    alertTextAsDescriptionDiv.classList.add('alert-by-asset');
                }
            } else {
                anchorTag = IllumioDomUtils.createAnchorTag(this.model.downloadType.toLowerCase(), record.file_name, 'download-link');
            }
            anchorTag.onclick = this.downloadAnchorOnClickHandler.bind(this);

            anchorTag.oncontextmenu = this.downloadAnchorOnContextMenuHandler;
            anchorTag.dataset['assetId'] = record.id;
            anchorTag.dataset['type'] = this.model.downloadType;

            if (record.zip_url) {
                const zip_url_parts = record.zip_url.split(".")
                const zip_url_extension = zip_url_parts[zip_url_parts.length-1]
                zipAnchorTag = IllumioDomUtils.createAnchorTag(this.model.downloadType.toLowerCase(), zip_url_extension.toUpperCase(), 'download-link');
                zipAnchorTag.onclick = this.downloadAnchorOnClickHandler.bind(this);
                zipAnchorTag.oncontextmenu = this.downloadAnchorOnContextMenuHandler;
                zipAnchorTag.dataset['assetId'] = record.id;
                zipAnchorTag.dataset['type'] = this.model.downloadType;
                zipAnchorTag.dataset['file'] = 'zip'
            }

            const checksumsAnchorTags = this.getChecksumsAnchorTags(record);
            // const softwareRelease = this.model.getSoftwareRelease(record.version);

            if (mode==='desktop') {
                const anchorTagCell = IllumioDomUtils.createTableCell(document.createTextNode(''));

                if (alertTextAsDescriptionDiv) {
                    anchorTagCell.appendChild(alertTextAsDescriptionDiv);
                }
                anchorTagCell.appendChild(anchorTag);

                if (record.software_type!=='k8s' && !record.file_name.match(/^https\:\/\//)) {
                    const sizeText = [];
                    sizeText.push(' (');
                    sizeText.push(IllumioSupportUtils.formatFileSizeInteger(record.size));
                    sizeText.push('\u00A0bytes)');

                    anchorTagCell.appendChild(document.createTextNode(' '));
                    anchorTagCell.appendChild(IllumioDomUtils.createSimpleTextBlock('nowrap', sizeText.join('')));

                    if (checksumsAnchorTags && checksumsAnchorTags.length>0) {
                        anchorTagCell.appendChild(document.createElement('br'));
                        anchorTagCell.appendChild(document.createTextNode('Checksums: '));
                        for (let j=0;j<checksumsAnchorTags.length;j++) {
                            anchorTagCell.appendChild(checksumsAnchorTags[j]);
                            anchorTagCell.appendChild(document.createTextNode(' '));
                        }
                    }

                    if (zipAnchorTag) {
                        anchorTagCell.appendChild(document.createElement('br'));
                        anchorTagCell.appendChild(document.createTextNode('Alternative: '));
                        anchorTagCell.appendChild(zipAnchorTag);
                    }
                }

                rootElement.appendChild(anchorTagCell);
                // rootElement.appendChild(IllumioDomUtils.createTableCell(IllumioSupportUtils.formatFileSizeInteger(record.size), 'size'));
            } else {
                let anchorTagDiv = null;
                if (alertTextAsDescriptionDiv) {
                    anchorTagDiv = IllumioDomUtils.createNode('div', alertTextAsDescriptionDiv);
                    anchorTagDiv.appendChild(anchorTag);
                } else {
                    anchorTagDiv = IllumioDomUtils.createNode('div', anchorTag);
                }
                if (zipAnchorTag) {
                    anchorTagDiv.appendChild(document.createElement('br'));
                    anchorTagDiv.appendChild(zipAnchorTag);
                }

                columnsElement.appendChild(anchorTagDiv);
                // console.debug(anchorTagDiv);

                if (record.software_type!=='k8s' && !record.file_name.match(/^https\:\/\//)) {
                    columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Size'));
                    columnsElement.appendChild(IllumioDomUtils.createNode('div', IllumioSupportUtils.formatFileSizeInteger(record.size)));
                    columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Checksum'));
                    columnsElement.appendChild(IllumioDomUtils.createNode('div', checksumsAnchorTags, 'checksum'));

                    if (zipAnchorTag) {
                        columnsElement.appendChild(IllumioDomUtils.createNode('div', 'Alternative'));
                        columnsElement.appendChild(IllumioDomUtils.createNode('div', zipAnchorTag));
                    }
                }

                rootElement.appendChild(columnsElement);
            }
        }

        return rootElement;
    }

    /* Append DOM nodes to doms object. */
    softwareComponentsForEachHandler(doms, displayCategory, record) {
        // console.debug('AssetListing: softwareComponentsForEachHandler(): ');

        if (doms && doms.desktop && doms.mobile &&
                (this.model.metadata.type!=='Upgrade' || (this.model.metadata.type==='Upgrade' && !record.file_name.match(/\.iso$/i))) &&
                (displayCategory===null || displayCategory===record.software_category) ) {
            doms.desktop.appendChild(this.createRecordViewDOM(record, 'desktop'));
            doms.mobile.appendChild(this.createRecordViewDOM(record, 'mobile'));

            // Remove Filename from th tag
            if (record && record.software_type==='k8s') {
                const ths = doms.desktop.getElementsByTagName('th');
                for (let i=ths.length-1;i>=0;i--) {
                    if (ths[i].textContent==='Filename') {
                        ths[i].textContent = ' ';
                    }
                }
            }
        }
    }

    versionsForEachHandler(elementArray, displayVersion, version) {
        console.debug('AssetListingView: versionsForEachHandler(): version: ' + version);
        if (this.model.data.software_components[version] && this.model.data.software_components[version].length>0) {
            let show_heading = false
            const filtered_software_components = {}
             for (let display_category in this.model.metadata.display_categories) {
                for (let i = 0; i < this.model.data.software_components[version].length; i++) {
                    if (display_category == this.model.data.software_components[version][i].software_category) {
                        if (!filtered_software_components[display_category]) {
                            filtered_software_components[display_category] = []
                            show_heading = true
                        }
                        filtered_software_components[display_category].push(this.model.data.software_components[version][i])
                    }
                }
            }

            if (displayVersion && show_heading) {
                const version_heading = document.createElement('h3');
                version_heading.textContent = version;
                elementArray.push(version_heading);
            }

            for (let display_category in filtered_software_components) {
                const doms = {
                    desktop: this.createTabularDOM('desktop'),
                    mobile: this.createTabularDOM('mobile'),
                }

                filtered_software_components[display_category].forEach(this.softwareComponentsForEachHandler.bind(this, doms, display_category));

                if (doms.mobile.childElementCount>0) {
                    let software_type_heading;
                    if (displayVersion) {
                        software_type_heading = document.createElement('h4');
                    } else {
                        software_type_heading = document.createElement('h3');
                    }
                    software_type_heading.textContent = this.model.metadata.display_categories[display_category].display_label;
                    elementArray.push(software_type_heading)

                    const softwareRelease = this.model.getSoftwareRelease(version);
                    // Temporary fix for duplicate notes
                    if (softwareRelease && softwareRelease.notes && display_category != 'ui' && display_category != 'ipfilter') {
                        const softwareReleaseNotes = this.createAlertByRelease(softwareRelease.notes,true);
                        const releaseNotes = document.getElementsByClassName("upgrade_alert");

                        const iconElement = document.createElement('i');
                        iconElement.style.marginRight = '0.5rem';
                        iconElement.classList.add('fa');
                        iconElement.classList.add('fa-exclamation-triangle');

                        const versionElement = document.createElement('span');
                        versionElement.style.fontSize = '1rem';
                        versionElement.style.fontWeight = 'bold';
                        versionElement.textContent = `Alert for ${softwareRelease.version}`;

                        const notesElement = document.createElement('span');
                        notesElement.classList.add('alert-by-release');
                        notesElement.appendChild(softwareReleaseNotes);
                        // alertElement.innerHTML = softwareReleaseNotes.innerHTML;

                        const alertByReleaseElement = document.createElement('p');
                        alertByReleaseElement.style.color = '#ff0000';
                        alertByReleaseElement.appendChild(iconElement);
                        alertByReleaseElement.appendChild(versionElement);
                        alertByReleaseElement.appendChild(notesElement);

                        if (display_category ==='pce'){
                            releaseNotes[0].appendChild(alertByReleaseElement);
                        } else if(display_category === 'vens'){
                            releaseNotes[1].appendChild(alertByReleaseElement);
                        }
                        elementArray.push(this.createAlertByRelease(softwareRelease.notes));
                    }
                    // SP-610
                    if (this.versions.length > 1 && version == this.versions[this.versions.length-1] && display_category != 'ui' && display_category != 'ipfilter') {
                        // let version_index = this.versions.indexOf(version)
                        const from_major_version = this.versions[0].split('+')[0]
                        const to_major_version = version.split('+')[0]
                        // let from_version_compatibility = this.version
                        // We only need to check if the nen compatibility exists for the from_major_version. If it doesn't,
                        // then that means they are not using NEN anyways
                        if (this.model.data.compatibilities && this.model.data.compatibilities[from_major_version] && this.model.data.compatibilities[from_major_version]['nen'] && !objectEqual(this.model.data.compatibilities[from_major_version]['nen'],this.model.data.compatibilities[to_major_version]['nen'])) {
                            elementArray.push(this.createAlertByRelease(`The NEN compatibility between ${this.versions[0]} and ${version} has changed. If you are using NEN, please confirm the current NEN is compatible with the new PCE <a href='/software/versions-and-compatibility.html#pce-compatibility'>here</a>.`));
                        }
                    }

                    elementArray.push(doms.desktop);
                    elementArray.push(doms.mobile);
                }
            }
        } else {
            console.warn('AssetListingView: versionsForEachHandler(): WARNING: Unable to determine the asset(s) for version ' + version);
        }
    }

    createAlertByRelease(text, triangleWarning) {
        triangleWarning = triangleWarning || 0;

        const pElement = document.createElement('p');
        pElement.classList.add('alert-by-release');
        if (triangleWarning===0) {
            const iElement = document.createElement('i');
            iElement.classList.add('fa');
            iElement.classList.add('fa-exclamation-triangle');
            pElement.appendChild(iElement);
        }

        const spanElement = IllumioDomUtils.parseHtml(text);
        const sanitizedSpanElement = IllumioDomUtils.sanitizeDOMTree(spanElement);
        pElement.appendChild(sanitizedSpanElement);

        return pElement
    }

    // Used for comparing shallow objects (no depth)
    objectEqual(obj1, obj2) {
        if (obj1 == obj2 || (!obj1 && !obj2)) {
            return true
        }
        if (obj1 && !obj2) {
            return false
        }
        if (!obj1 && obj2) {
            return false
        }

        const obj1_keys = Object.keys(obj1).sort()
        const obj2_keys = Object.keys(obj2).sort()
        if (obj1_keys.length != obj2_keys.length){
            return false
        }

        for (let i = 0; i < obj1_keys.length; i++) {
            if (obj1_keys[i] != obj2_keys[i]) {
                return false
            }
            if (obj1[obj1_keys[i]] != obj2[obj2_keys[i]]) {
                return false
            }
        }
        return true
    }

    displayCategoriesForEachHandler(resultElement, index) {
        console.debug('AssetListingView: displayCategoriesForEachHandler(): ');
        console.debug(resultElement);
        console.debug(this.versions);

        const elementArray = [];
        const assetVersions = (this.versions.length>1 && this.model.metadata.type=='Upgrade') ? this.versions.slice(1) : this.versions;
        assetVersions.forEach(this.versionsForEachHandler.bind(this, elementArray, (assetVersions.length>1)));

        for (let i=0;i<elementArray.length;i++) {
            resultElement.appendChild(elementArray[i]);
        }
    }

        render(versions) {
            this.versions = versions;

            if (!this.model.metadata || !this.model.data) {
                console.error('AssetListingView: render(): Unable to render the asset listing due to missing metadata and/or data!');
                return;
            }

            IllumioDomUtils.removeChildren(this.downloadElement);
            const upgradeAlert = document.getElementsByClassName("upgrade_alert");
            for (let i = upgradeAlert.length-1; i>=0; i--){
                IllumioDomUtils.removeChildren(upgradeAlert[i]);
            }

            if (this.versions && this.versions.length>0) {
                // Create DOM for displaying software listing, group by categories.
                // Assumption: this.model.data.software_components is of Hash type.
                const resultElement = document.createElement('div');

                let categoriesCount = 0;
                if (this.model.metadata.display_categories) {
                    const displayCategories = Object.keys(this.model.metadata.display_categories);
                    this.displayCategoriesForEachHandler(resultElement);

                    this.downloadElement.appendChild(resultElement);
                    this.downloadElement.classList.remove('hidden');

                    categoriesCount = displayCategories.length;
                    //console.log('THIS IS THE MODEL DATA')
                    //console.log(this.model.metadata)

                    if (this.model.metadata.eula_required) {
                        this.eulaElement.classList.remove('hidden');
                    } else {
                        this.eulaElement.classList.add('hidden');
                    }
                } else {
                    this.eulaElement.classList.add('hidden');
                }

                if (categoriesCount===0) {
                    console.warn('AssetListingView: render(): Unable to generate listing by category due to missing category.');
                }
            } else if (!this.versions &&
                    this.model.data &&
                    this.model.data.software_components &&
                    this.model.data.software_components.constructor===Array) {
                // Create DOM for displaying sofrtware listing.
                // this.model.software_components is of Array type.
                console.warn(this.model);
                // console.warn(this);

                const resultElement = document.createElement('div');
                resultElement.classList.add('small-16');
                resultElement.classList.add('columns');

                if (this.model.data.software_components.length>0) {
                    const doms = {
                        desktop: this.createTabularDOM('desktop'),
                        mobile: this.createTabularDOM('mobile'),
                    }
                    this.model.data.software_components.forEach(this.softwareComponentsForEachHandler.bind(this, doms, null));

                    resultElement.appendChild(doms.desktop);
                    resultElement.appendChild(doms.mobile);

                    this.downloadElement.appendChild(resultElement);
                    this.downloadElement.classList.remove('hidden');
                    //console.log('THIS IS THE MODEL DATA2')
                    //console.log(this.model.metadata)

                    if (this.model.metadata.eula_required) {
                        this.eulaElement.classList.remove('hidden');
                    } else {
                        this.eulaElement.classList.add('hidden');
                    }
                } else {
                    const messageElement = document.createElement('p');
                    messageElement.textContent = 'There is no custom build available for you.';

                    resultElement.appendChild(messageElement);
                }
            } else {
                console.error('AssetListingView: render(): Unable to generate listing due to missing version(s).');
            }
        }

    // --- DOM event handlers -----------------------------------------
    downloadAnchorOnClickHandler(event) {
        event.preventDefault();

        console.debug('AssetListingView: downloadAnchorOnClickHandler()');
        // this.downloadEvent.notify(event.target);
        this.emit('download', { anchorElement: event.target });

        return false;
    }

    downloadAnchorOnContextMenuHandler(event) {
        console.info('AssetListingView: downloadAnchorOnContextMenuHandler(): Context menu disabled!');
        return false;
    }

    checksumAnchorOnClickHandler(event) {
        console.debug('AssetListingView: checksumAnchorOnClickHandler(): Tracking checksum label ' + event.target.dataset['gaEventLabel']);
        if (event.target && event.target.dataset['gaEventLabel']) {
            IllumioSupportUtils.trackGaEvent('PCE Software', 'Checksum', event.target.dataset['gaEventLabel']);
        }
    }

    // --- DOM utility functions --------------------------------------
    createTabularDOM(mode) {
        let rootElement = null;

        if (!mode) { mode = 'desktop'; }
        if (mode==='mobile') {
            rootElement = document.createElement('div');
            rootElement.classList.add('ilo-tabular');
            rootElement.classList.add('show-for-small-only');
            rootElement.classList.add('mobile-view');
        } else {
            rootElement = document.createElement('table');
            rootElement.classList.add('ilo-tabular');
            rootElement.classList.add('show-for-medium-up');
            rootElement.classList.add('desktop-view');

            rootElement.appendChild(this.createHeadingDesktopViewDOM());
        }
        return rootElement;
    }

    createHeadingDesktopViewDOM() {
        const rootElement = document.createElement('tr');

        const headings = [ 'Description', 'Release Date', 'Version', 'Filename' ];
        const headingsForEachHandler = function(item) {
            rootElement.appendChild(IllumioDomUtils.createTableCell(item, (item==='Description') ? item.toLowerCase() : null, true));
        }
        headings.forEach(headingsForEachHandler);

        return rootElement;
    }
}

export class AssetListingController extends IllumioEventEmitter {
    constructor(model, view) {
        super();

        this.model = model;
        this.view = view;
        const eulaModel = new EulaModel();
        const eulaView = new EulaView(eulaModel);
        eulaView.eulaElement = this.view.eulaElement;
        eulaView.errorElement = this.view.errorElement;
        this.eulaController = new EulaController(eulaModel, eulaView);
        // this.view.downloadEvent.attach(this.downloadEventHandler.bind(this));
        this.view.on('download', this.downloadEventHandler.bind(this));
    }

    downloadEventHandler(payload) {
        if (this.isDebug()) { console.debug(`» downloadEventHandler(): payload: ${JSON.stringify(payload)}`); }

        const anchorElement = (payload && payload.anchorElement) ? payload.anchorElement : null;

        let proceedToDownload = false;
console.debug(this.model);
console.debug(this.eulaController.model.isEulaAccepted());
        if (this.model.metadata && this.model.metadata.eula_required && this.model.metadata.eula_required===true) {
            if (this.eulaController.model.isEulaAccepted()) {
                // EULA is accepted
            	proceedToDownload = true;
            } else {
                if (anchorElement) {
                    // EULA is NOT accepted yet
                    this.eulaController.view.renderAcceptanceRequirementAlert(anchorElement);
                } else {
                    console.warn(`downloadEventHandler(): Missing anchorElement in payload! ${JSON.stringify(payload)}`);
                }
            }
        } else if (this.model.metadata && this.model.metadata.eula_required===false) {
            console.debug('AssetListingController: downloadEventHandler(): EULA Acceptance is not required.')
            proceedToDownload = true;
        } else {
            console.error('AssetListingController: downloadEventHandler(): EULA Acceptance requirement is NOT detected!');
        }

        if (anchorElement.dataset) { console.debug(`» anchorElement.dataset['assetId']: ${anchorElement.dataset['assetId']}`); }
        if (proceedToDownload===true && anchorElement && anchorElement.dataset && anchorElement.dataset['assetId']) {
            const asset = this.model.getAsset(anchorElement.dataset['assetId']);
            const assetDownload = new AssetDownload(this.model.metadata, asset, this.eulaController.model.acceptanceId);
            assetDownload.setDownloadZip((anchorElement.dataset['file'] && anchorElement.dataset['file']==='zip') ? true : false);
            assetDownload.download();
        } else {
            console.warn('AssetListingController: downloadEventHandler(): Unable to determine the asset ID to move on.');
        }
    }

        setModelData(metadata, data) {
            this.model.metadata = metadata;
            this.model.data = data;
            if (this.model.metadata) {
                this.model.downloadType = metadata.type;
            }

            this.eulaController.model.product = this.model.metadata.product;
            this.eulaController.model.type = this.model.metadata.type;
            if (this.model.metadata.eula_url) {
                this.eulaController.view.updateEulaURL(this.model.metadata.eula_url)
            }
        }
}